import SampleReportView from "@/components/samples/SampleReportView";
import { VERDE_REPORT } from "@/data/sample-reports";

const VerdeSample = () => <SampleReportView report={VERDE_REPORT} />;

export default VerdeSample;
